import { MetaConversation } from 'lib-shared-legacy-types';

import ConversationSummaryHelper from 'app/utils/conversationSummaryHelper';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const REPLY_WINDOW_IN_MILLIS = 24 * HOUR - 1 * MINUTE;

/**
 * Returns a timestamp of when an agent can't reply to the conversation any
 * longer.
 */
export function getReplyWindowExpiresOnFromConversation(
  metaConversation: MetaConversation,
): Date | undefined {
  const helper = new ConversationSummaryHelper(metaConversation);

  const { conversation } = metaConversation;

  const transport_expires_at = conversation.attributes?.transport_expires_at;
  if (transport_expires_at) {
    return new Date(transport_expires_at);
  }

  const eventsPresent = (conversation.events?.length ?? 0) > 0;
  const authorsPresent = Object.keys(conversation?.authors ?? {}).length > 0;
  const channelIsFacebookMessenger = helper.isChannelFacebookMessenger();

  if (!eventsPresent || !authorsPresent || !channelIsFacebookMessenger) {
    return undefined;
  }

  const endUserId = helper.getRequestedBy();

  const lastMessageFromEndUser = [...metaConversation.messages]
    .reverse()
    .find(
      (message) =>
        message.author_id === endUserId &&
        message.type === 'conversation:message_added',
    );

  if (!lastMessageFromEndUser?.created_at) {
    return undefined;
  }

  const lastMessageFromEndUserDate = new Date(
    lastMessageFromEndUser.created_at,
  );

  return new Date(
    lastMessageFromEndUserDate.getTime() + REPLY_WINDOW_IN_MILLIS,
  );
}
